export const tableColumns = [
    {
        name: 'Donation ID',
        selector: row => row.donation_history_id,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Transaction ID',
        selector: row => row.transaction_id,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Donor Name',
        selector: row => row.payee_name,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        wrap: true
    },
    {
        name: 'Donor Email',
        selector: row => row.donor_email,
        sortable: true,
        center: true,
        minWidth: '9.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Benificary Name',
        selector: row => row.object_name,
        sortable: true,
        center: true,
        minWidth: '5.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Benificary Type',
        selector: row => row.object_type,
        sortable: true,
        center: true,
        minWidth: '5.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Donation Amt',
        selector: row => row.donation_amount,
        sortable: true,
        center: true,
        width: '3.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Convenience Fee',
        selector: row => row.convenience_fee,
        sortable: true,
        center: true,
        width: '3.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Net Amt',
        selector: row => row.net_amount,
        sortable: true,
        center: true,
        width: '3.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Date & Time',
        selector: row => row.date_time, 
        sortable: true,
        center: true,
        width: '3.375rem',
        style: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Payment Status',
        selector: row => row.payment_status,
        sortable: true,
        center: true,
        width: '3.375rem',
        id: 'payment_status'  // Added for sticky positioning
    },
];